import { useQuery } from "react-query"
import customAxios from "../utils/customAxios"

const axios = customAxios()

const fetchPolicyApi = ({ queryKey }: any) => {
  const prop = queryKey[1] // parse value
  return axios.get(`/policy/${prop}`)
}

export const usePolicy = (prop?: any) => {
  return useQuery(["fetchPolicyApi", prop], fetchPolicyApi, {
    staleTime: 10000,
    select: select,
    onError,
    refetchOnWindowFocus: false,
  })
}

// api 응답 데이터 가공하는 부분
const select = (response: any) => {
  return response.data
}

const onError = (err: any) => {
  return err
}
